/**
 * Chat Components Index
 *
 * React components for chat UI.
 */

// Presence components
export { PresenceProvider } from './presence-provider';
export { AvatarWithStatus } from './avatar-with-status';

// Admin support messaging
export { MessageAsBalleeSupportDialog } from './message-as-ballee-support-dialog';

// Avatar components
export { AvatarGroup, type AvatarGroupParticipant } from './avatar-group';
